import { FunctionComponent } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { useDispatch, useSelector } from 'react-redux';
import { ReadMore } from './readMore/readMore';
import { videoDataSelector } from '../../common/store/selectors/videoData.selector';
import { isEmpty, isEmptyObject } from '../../common/utils/utils';
import { splitViewSelector } from '../../common/store/selectors/splitView.selector';
import { playerDataSelector } from '../../common/store/selectors/playerData.selector';
import { setNumberOfScenes, resetRecirculationData } from '../../core/store/playerData/playerDataSlice';

const REGEX = /\d+/;

interface CustomParam {
  endOfScene: number;
  sceneUrl: string;
}

export type RecirculationCustomParams = Array<CustomParam>;

const extractTimeSegmentFromKeyValue = (customParam: Array<any>): CustomParam => {
  const key = customParam[0];
  const endOfScene = key.match(REGEX);
  if (endOfScene) {
    return {
      endOfScene: parseInt(endOfScene.toString(), 10),
      sceneUrl: customParam[1],
    };
  }
  return null;
};

const ReadMorePlugin: FunctionComponent = () => {
  const dispatch = useDispatch();
  const customParams = useSelector(videoDataSelector.customParams);
  const splitViewRatio = useSelector(splitViewSelector.splitViewRatio);
  const videoTagStatus = useSelector(playerDataSelector.videoTagStatus);
  const loadingPlayer = useSelector(playerDataSelector.loadingPlayer);

  const [sortedCustomParams, setSortedCustomParams] = useState<RecirculationCustomParams>([]);
  const showReadMore = !isEmpty(sortedCustomParams) && isEmpty(splitViewRatio) && !loadingPlayer && videoTagStatus !== 'unloaded';

  useEffect(() => {
    if (videoTagStatus === 'unloaded') {
      dispatch(resetRecirculationData());
    }
  }, [dispatch, videoTagStatus]);

  useEffect(() => {
    if (showReadMore) {
      dispatch(setNumberOfScenes(sortedCustomParams.length));
    }
  }, [showReadMore, sortedCustomParams, dispatch]);

  useEffect(() => {
    if (!isEmptyObject(customParams)) {
      const formattedList: RecirculationCustomParams = Object.entries(customParams).map(extractTimeSegmentFromKeyValue);
      const filteredNewList: RecirculationCustomParams = formattedList.filter(customParam => !isEmpty(customParam));
      setSortedCustomParams(filteredNewList.sort((a, b) => a.endOfScene - b.endOfScene));
    } else {
      setSortedCustomParams([]);
    }
  }, [customParams]);

  return showReadMore && <ReadMore sortedCustomParams={sortedCustomParams} />;
};

export default ReadMorePlugin;
